import { render } from "./chartRadarStyle.vue?vue&type=template&id=5cf9da5c"
import script from "./chartRadarStyle.vue?vue&type=script&lang=js"
export * from "./chartRadarStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__